import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, NavigationEnd } from '@angular/router';
import { SessionService } from '../providers/session.service'
 
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss', '../assets/less/all.less']
})
export class AppComponent {
	title = 'gsviewer';
	session;
	sessao;
	adm = false
	showNav: boolean;
    showSideBar;
	isLoggedIn = false;

	constructor(
		public router: Router,
		public dialog: MatDialog,
		public session_provider: SessionService,
	) { }


	// NO ON INIT É INSTANCIADA UMA FUNCAO QUE AGUARDA UMA PROMISE DO PROVIDER DE getSessao
	// QUANDO RETORNA FALSE CHAMA O LOGIN DE NOVO
	// QUANDO RETORNA TRUE SETA A isLoggedIn TRUE E CHAMA A ROTA DA TELA INICIAL
	ngOnInit() {
		
		this.router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				let urlSlice = e.url.toString().substr(0, 10);
				this.isLoggedIn = false;
				if (urlSlice.indexOf('login') !== -1) {
					this.session_provider.getSessao(null).then(res => {
						if (!res) {
							this.isLoggedIn = false;
							this.openLogin();
						}
						else {
							this.session = res;
							this.isLoggedIn = true;
							this.getAdministrador()
							this.getDadosSessao()
						}
					})
				}
				else {
					this.session_provider.getSessao(null).then(res => {
						console.log("res session provider", res)
						if (!res) {
							this.isLoggedIn = false;
							this.openLogin();
						}
						else {
							this.getAdministrador()
							this.getDadosSessao()
							// console.log("else login else getsession", res)
							this.session = res;
							this.isLoggedIn = true;
							console.log('this session', this.sessao)
						}
					})
				}
			}
			
		});
	}
	
	getAdministrador(){
		
		// this.session_provider.getAdm()
		this.adm = this.session_provider.getAdm()
	}

	openLogin(){
		
		this.router.navigate(['/login'])
		
	}

	getDadosSessao(){
		let dadosSession = this.session_provider.getDadosSessao()
		if(dadosSession != null){
			this.sessao = dadosSession
		}
	}

	logout(){
        this.session_provider.remove_sessao();
        this.isLoggedIn = false;
		this.openLogin();
    }

	openAdministracao(){
		
		this.router.navigate(['/administracao'])
		
	}

	openResetSenha(){
		
		this.router.navigate(['/password'])
		
	}

	openDocumentosGed(){
		
		this.router.navigate(['/documentos-ged'])
		
	}

	openUpload(){
		
		this.router.navigate(['/upload'])
		
	}

	openDialog() {
		const dialogRef = this.dialog.open(AppComponent, {
			height: '350px'
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log(`Dialog result: ${result}`);
		});
	}
}
